import { CashbackWizardContext } from "@features/cashbackWizard2.0/types";
import {
  isNewUser,
  isPrivateAccount,
} from "@features/cashbackWizard2.0/utils/guards";

export const getWorkflowType = (context?: CashbackWizardContext) => {
  if (!context) return null;

  if (isNewUser(context) && isPrivateAccount(context)) {
    return "newDepot";
  } else if (isNewUser(context) && !isPrivateAccount(context)) {
    return "newCompanyDepot";
  } else if (!isNewUser(context) && isPrivateAccount(context)) {
    return "existingDepot";
  } else if (!isNewUser(context) && !isPrivateAccount(context)) {
    return "existingCompanyDepot";
  }

  return null;
};
